import React, { useState, useEffect, useContext } from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTable,
  faTableCells,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import api from "../api/api";
import Table from "./Table";
import Cards from "./Cards";
import FilterSidebar from "./FilterSidebar";
import { FilterContext } from "../context/FilterContext";
import axios from "axios";
import { cloneDeep } from "lodash";

const headers = [
  { label: "Company Name", key: "title" },
  { label: "Company Address", key: "address" },
  { label: "State", key: "state" },
  { label: "Congressional District", key: "district" },
  { label: "Contact Name", key: "contact_name" },
  { label: "Contact Email", key: "contact_email" },
  { label: "Primary IC", key: "primary_ic" },
  { label: "Technology Type", key: "technology_type" },
  { label: "Showcase Event", key: "eventsToString" },
  { label: "Website", key: "website" },
];

function CompanyListing() {
  const [companies, setCompanies] = useState([]);
  const [fullSet, setFullSet] = useState([]);
  const [pending, setPending] = useState(true);
  const [cardSelected, setCardSelected] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState([12, 24, 48, 96]);
  const [paginationPerPage, setPaginationPerPage] = useState(12);
  const {
    selectedOrgs,
    selectedTechs,
    selectedDemos,
    selectedStates,
    selectedOwnership,
    setOrg,
  } = useContext(FilterContext);
  const [taxonomy, setTaxonomy] = useState([]); // Sponsoring Organization taxonomy
  const [mappedTaxonomy, setMappedTaxonomy] = useState([]); // Mapped Sponsoring Organization taxonomy
  const [year,SetYear] = useState(null)


  useEffect(() => {
    const fetchData = () => {
      api.get(`https://seed.nih.gov/organization-events-taxonomy.json`).then((res) => {
        const data = cloneDeep(res.data);
        setTaxonomy(data);

        let root = res.data.filter((t) => t.parent_target_id === "");
        let children = res.data.filter((t) => t.parent_target_id !== "");
        root.map((term) => {
          term.children = children.filter(
            (t) => t.parent_target_id === term.tid
          );
        });
        setMappedTaxonomy(root);

        api.get(`/api/companies`).then((res) => {

          res.data.forEach((item, idx) => {
            if (
              item.showcase_events &&
              Object.keys(item.showcase_events).length > 0
            ) {
              let f_events = [];
              let f_events_string = [];
              Object.keys(item.showcase_events).forEach((key) => {
                f_events.push({
                  sponsoring_organization: key,
                  year: item.showcase_events[key],
                });
                item.showcase_events[key].map(i=>{
                  f_events_string.push(key + " " + i);
                })
                
              });
              item.events = f_events;
              item.eventsToString = f_events_string;
            } else {
              item.events = [];
              item.eventsToString = "";
            }
          });


          const query = window.location.search;
          const queryParams = new URLSearchParams(query);

          let query_events = queryParams.get("events");
          let query_year = queryParams.get("year");
          if(query_year){
            query_year = parseInt(query_year)
            SetYear(query_year)
          }
          if (query_events) {
            let query_events_f = [];
            query_events = query_events.split(",");
            query_events.map((e) => {
              query_events_f.push({
                label: e,
                value: e,
              });
            });
            setOrg(query_events_f);
            let list = filterOrgs(res.data, query_events_f, root,query_year)
            setCompanies(list);
          } else {
            setCompanies(res.data);
          }
          setFullSet(res.data);
          setPending(false);
        });
      });
    };

    fetchData();
  }, []);


  /**
   * State filter hook
   *
   * TODO: implement filtering for the rest
   */
  useEffect(() => {
    let list = fullSet;
    if (
      selectedStates.length === 0 &&
      selectedOrgs.length === 0 &&
      selectedTechs.length === 0 &&
      selectedDemos.length === 0 &&
      selectedOwnership === 0
    ) {
      setCompanies(fullSet);
    } else {
      if (selectedStates.length > 0) {
        list = list.filter((c) =>
          selectedStates.find(({ value }) => value === c.state)
        );
      }

      if (selectedTechs.length > 0) {
        list = list.filter((c) =>
          selectedTechs.find(
            ({ value }) =>
              value ===
              c.technology_type.split("|").find((element) => element === value)
          )
        );
      }

      if (selectedDemos.length > 0) {
        list = list.filter((c) =>
          selectedDemos.find(
            ({ value }) =>
              value ===
              c.innovator.split("|").find((element) => element === value)
          )
        );
      }

      if (selectedOwnership.length > 0) {
        list = list.filter((c) =>
          selectedOwnership.every(
            ({ value }) =>
              value ===
              c.company_ownership
                .split("|")
                .find((element) => element === value)
          )
        );
      }

      if (selectedOrgs.length > 0) {
        list = filterOrgs(list, selectedOrgs, mappedTaxonomy, year)
      }
      setCompanies(list);
    }
  }, [
    selectedStates,
    selectedTechs,
    selectedDemos,
    selectedOrgs,
    selectedOwnership,
  ]);

  const filterOrgs = (list, selected_orgs, m_taxonomy, s_year) => {
    list = list.filter((c) =>
      selected_orgs.find(({ value }) => {
        if (c.events.length > 0) {
          //let t = c.events.find( e => e.sponsoring_organization === value)
          if(year){
            if (c.events.find((e) => e.sponsoring_organization === value && e.year.includes(s_year)))
              return true;
          } else {
            if (c.events.find((e) => e.sponsoring_organization === value))
              return true;
          }


          // If nested taxonomy is used to create the sponsored event
          let term = m_taxonomy.find((t) => t.name === value);

          if (term) {
            let found = null;
            if(year){
              found = term.children.filter((t) =>
                c.events.find((e) => e.sponsoring_organization === t.name && e.year.includes(s_year))
              );
            } else {
              found = term.children.filter((t) =>
                c.events.find((e) => e.sponsoring_organization === t.name)
              );
            }

            if (found && found.length > 0) {
              return true;
            }
          }
        }
      })
    );
    return list;
  };

  const onTabSelect = (state) => {
    setCardSelected(state);
  };

  const onDisplayPerPageChange = (e) => {
    let { name, value } = e.target;
    setPaginationPerPage(value);
  };

  return (
    <div className="flex-grid">
      <div className="col">{pending === false ? <FilterSidebar /> : ""}</div>
      <div className="col">
        <div className="company-listing">
          <CSVLink
            data={fullSet}
            headers={headers}
            filename={"companies.csv"}
            className="download"
          >
            <FontAwesomeIcon icon={faDownload} /> Download as an Excel File
          </CSVLink>
          <div className="company-controls">
            <h2>Company Listing</h2>
            <div className="controls">
              <div className="per-page-dd">
                <label htmlFor="per_page">Display Per Page</label>
                <select
                  name="per_page"
                  id="per_page"
                  defaultValue={paginationPerPage}
                  onChange={(e) => onDisplayPerPageChange(e)}
                >
                  {itemsPerPage.map((pageNumber, i) => {
                    return (
                      <option value={pageNumber} key={i}>
                        {pageNumber}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="list-tab">
                <button
                  onClick={() => {
                    onTabSelect(true);
                  }}
                  className={`card-button ${cardSelected ? "active" : ""}`}
                >
                  <FontAwesomeIcon icon={faTableCells} /> Card View
                </button>
                <button
                  onClick={() => {
                    onTabSelect(false);
                  }}
                  className={`table-button ${cardSelected ? "" : "active"}`}
                >
                  <FontAwesomeIcon icon={faTable} /> Table View
                </button>
              </div>
            </div>
          </div>
          {cardSelected === true ? (
            <Cards
              companies={companies}
              paginationPerPage={paginationPerPage}
              pending={pending}
            />
          ) : (
            <Table
              companies={companies}
              paginationPerPage={paginationPerPage}
              pending={pending}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CompanyListing;
